import san, {Component as SanComponent, defineComponent} from 'san';
import {PAGE_TYPE} from '@lib/constants';
import {domHeight, DomHeightRecoder} from './utils/dom';

interface ComponentProps {
    _store?: any;
    _emitter?: any;
}

// @ts-ignore
SanComponent.prototype.trimWhitespace = 'all';

class Component<
    T extends {
        [key: string]: any;
    } = {},
> extends SanComponent<T> {
    private readonly _store: any;
    private readonly _emitter: any;
    d: T;

    constructor(props: T) {
        super(props);
        this.d = {} as T;
    }

    get store() {
        return this.upward('_store');
    }

    get emitter() {
        return this.upward('_emitter');
    }

    upward(prop: keyof ComponentProps) {
        let component = this as Component<T>;

        while (component) {
            if (component[prop]) {
                return component[prop];
            }
            component = component.parentComponent as Component<T>;
        }

        return null;
    }

    /**
     * 组件初始化的时候，设置 dom 高度
     * 1、找到固定特征的组件
     * 2、设置高度
     */
    created() {
        const hostTag = this.data.get('hostTag');
        const from = this.data.get('from');
        // eslint-disable-next-line @typescript-eslint/prefer-includes
        if (
            (this.el as HTMLElement)?.className?.indexOf(DomHeightRecoder.PREFIX) > -1
            // 多摸页面不需要设置高度
            && !this.data.get('isMultiPage')
            // 过滤其他的页面
            && !this.data.get('isFromYiyan')
            && (hostTag === PAGE_TYPE.MAIN
                || (hostTag === PAGE_TYPE.SECOND && !['create_video_virtual'].includes(from)))
        ) {
            domHeight?.setDomHeight({
                $container: this.el as HTMLElement,
                itemData: this.data.get('itemData'),
            });
            this.emitter?.on('updateFontSize', () => {
                // 监听到字体变化，去除设置的高度
                domHeight?.clearDomHeight({
                    $container: this.el as HTMLElement,
                    itemData: this.data.get('itemData'),
                });
            });

            // 由于最后一个组件是复用的，需要监听一下messageId变化，把设置的高度去除
            this.watch('itemData.messageId', () => {
                domHeight?.clearDomHeight({
                    $container: this.el as HTMLElement,
                    itemData: this.data.get('itemData'),
                });
            });

            this.emitter?.on(DomHeightRecoder.CLEAR_DOM_HEIGHT, (params: any) => {
                const {updateHeight, messageId} = params;
                if (messageId === this.data.get('itemData.messageId')) {
                    domHeight?.clearDomHeight({
                        $container: this.el as HTMLElement,
                        itemData: this.data.get('itemData'),
                        updateHeight,
                    });
                }
            });
        }
    }

    /**
     * 数据变动引起 dom 变化时，设置最新 dom 高度
     */
    updated() {
        /**
         * TODO: 监听字体变化，清除缓存
         * 1、如果 webview 不重新加载，则需要清除缓存
         * 2、如果 webview 重新拉了历史，则不处理
         */
        this.nextTick(() => {
            const hostTag = this.data.get('hostTag');
            const from = this.data.get('from');
            // eslint-disable-next-line @typescript-eslint/prefer-includes
            if (
                (this.el as HTMLElement)?.className?.indexOf(DomHeightRecoder.PREFIX) > -1
                // 过滤其他的页面
                && !this.data.get('isFromYiyan')
                && (hostTag === PAGE_TYPE.MAIN
                    || (hostTag === PAGE_TYPE.SECOND && !['create_video_virtual'].includes(from)))
            ) {
                domHeight?.saveDomHeight({
                    $container: this.el as HTMLElement,
                    itemData: this.data.get('itemData'),
                    answerFinish: this.data.get('answerFinish'),
                    isLast: this.data.get('isLast'),
                });
            }
        });
    }

    watchState(stateList: string[]) {
        stateList.forEach(item => {
            this.data.set(item, this.store?.get(item));
            this.store?.watch(item, ({newValue}: any) => {
                this.data.set(item, newValue);
            });
        });
    }
}

export default san;

export {Component, defineComponent};
